function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleRegisterAccountRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.158 15.612a.988.988 0 01-.23-1.547c1.39-1.482 2.085-2.732 2.085-6.065 0-3-2.001-6-6.006-6-4.001 0-6.003 3-6.003 6 0 3.333.695 4.583 2.085 6.065a.988.988 0 01-.23 1.547C7.52 16.356 5.324 17.678 4.002 19c-1.677 1.675-1.95 5.456-1.994 8.991a1.986 1.986 0 001.99 2.01h18.02a1.987 1.987 0 001.99-2.01c-.044-3.535-.316-7.316-1.992-8.99-1.323-1.323-3.52-2.645-4.858-3.389zM26 6V2h-2v4h-4v2h4v4h2V8h4V6h-4z",
    fill: props.color
  }));
}

export default SvgIconPeopleRegisterAccountRexFilled;